import { ValuationsType } from '../utility/types';
import { updatePropertyDecision } from '../api/ListSortPropertyJoin/updateListSortPropertyJoin';
import { useQueryClient } from '@tanstack/react-query';

export type DecisionFormDataProps = {
    wanted: boolean | null;
    notes: string;

    approach_id: string | null;
    valuations_option: ValuationsType;
    estimated_value: number | null;
    estimated_value_per_sqft: number | null;
    fix_costs: number;

    max_bid: number | null;
    max_bid_per_sqft: number | null;
    estimated_profit: number | null;
    roi: number | null;

    user_estimated_value: number | null;
    user_estimated_value_sqft: number | null;
    user_fixed_costs: number | null;
  };

const formatFormDataForRequest = (state: any): DecisionFormDataProps => {
  return {
    wanted: state?.wanted, // must be true
    // status: state?.wanted, // must be true
    notes: '',
    approach_id: state?.approachId,  // must be present
    valuations_option: state?.valuationType, // must be present
    estimated_value: state?.estimatedValue, // ONLY  if user input is selected
    estimated_value_per_sqft: state?.estimatedValuePerSqft, // ONLY  if user input is selected
    fix_costs: state?.fixedCosts,
    max_bid: state?.maxBid,
    max_bid_per_sqft: state?.maxBidPerSqft,
    estimated_profit: state?.estimatedProfit,
    roi: state?.roi,
    // User Input
    user_estimated_value: state?.userEstimatedValue,
    user_estimated_value_sqft: state?.userEstimatedValueSqft,
    user_fixed_costs: state?.userFixedCosts,
  };
};

export const useDecisionSubmission = () => {
  const queryClient = useQueryClient();

  const submitDecision = async (state: any, activeListSortId: string, activePropertyId: string) => {
    const formData = formatFormDataForRequest(state);
    try {
      const result = await updatePropertyDecision({
        requestBody: formData,
        listSortId: activeListSortId,
        propertyId: activePropertyId,
      });
      console.log('useDecisionSubmission - result', result);

      // Invalidate queries to refresh the data
      queryClient.invalidateQueries({ queryKey: [ 'get-list-sorts' ] });
      queryClient.invalidateQueries({ queryKey: [ 'list-sort-property-join', activeListSortId ] });
      queryClient.invalidateQueries({ queryKey: [ 'getPropertyListSortPropertyJoins', activePropertyId ] });

      return result;
    } catch (error) {
      console.error('useDecisionSubmission - Failed to submit decision:', error);
      throw error;
    }
  };

  return { submitDecision };
};
